import { render } from "./DeleteStaff.vue?vue&type=template&id=3aaa0ce0"
import script from "./DeleteStaff.vue?vue&type=script&lang=js"
export * from "./DeleteStaff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__